module.exports = __webpack_public_path__ + "img/more.afef9a20.svg";